export default function isEmptyString(maybeString: unknown): boolean {
  return (
    typeof maybeString === 'string' &&
    maybeString.trim().replace(/\s+/gi, '').length === 0
  )
}
